// Modules
import React from 'react';
import { inject, observer } from 'mobx-react';

// Material-UI
import Toolbar from 'material-ui/Toolbar';
import { FormGroup, FormControlLabel } from 'material-ui/Form';
import Checkbox from 'material-ui/Checkbox';

// Components
import PageChrome from '../PageChrome';
import MapContainer from '../MapContainer';

// Styles
import './style.css';

@inject('PinStore')
@observer
export default class extends React.Component {
  render() {
    const { PinStore } = this.props;
    const { categories } = PinStore;
    return (
      <PageChrome
        {...this.props}
        title="Map"
        noPadding
      >
        <Toolbar>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={categories.waterWasteWater}
                  onChange={(e, checked) => { PinStore.categories.waterWasteWater = checked; }}
                />
              }
              label="Water / Waste Water"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={categories.competitor}
                  onChange={(e, checked) => { PinStore.categories.competitor = checked; }}
                />
              }
              label="Competitors"
            />
          </FormGroup>
        </Toolbar>
        <MapContainer />
      </PageChrome>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js